import _ from '@lodash';
import auth0Service from 'app/services/auth0Service';
import firebaseService from 'app/services/firebaseService';
import jwtService from 'app/services/jwtService';
import * as MessageActions from 'app/store/actions/fuse/message.actions';
import * as FuseActions from 'app/store/actions/fuse';
import firebase from 'firebase/app';
import axios from 'axios';
import * as UserActions from './user.actions';

export const GET_USER_DATA = '[USER] GET DATA';
export const GET_USER_DATA_ERROR = '[USER] GET DATA ERROR';
export const SET_USER_DATA = '[USER] SET DATA';
export const REMOVE_USER_DATA = '[USER] REMOVE DATA';
export const USER_LOGGED_OUT = '[USER] LOGGED OUT';
export const REFRESH_TOKEN = '[TOKEN] REFRESH TOKEN';
export const LOGOUT_SUCCESS = '[TOKEN] LOGOUT_SUCCESS';

/**
 * Get user data
 */
export function getUserData() {
	return (dispatch, data) => {
		if(!data.isError) {
			dispatch(UserActions.setUserData(data.userDetails));
			return dispatch({
				type: GET_USER_DATA
			});

		} else {
			alert(data.errors);
			return dispatch({
				type: GET_USER_DATA_ERROR,
				payload: data.errors
			});
		}
	}
}

/**
 * Set user data from Auth0 token data
 */
export function setUserDataAuth0(tokenData) {
	const user = {
		role: ['admin'],
		from: 'auth0',
		data: {
			displayName: tokenData.username,
			photoURL: tokenData.picture,
			email: tokenData.email,
			settings:
				tokenData.user_metadata && tokenData.user_metadata.settings ? tokenData.user_metadata.settings : {},
			shortcuts:
				tokenData.user_metadata && tokenData.user_metadata.shortcuts ? tokenData.user_metadata.shortcuts : []
		}
	};

	return setUserData(user);
}

/**
 * Set user data from Firebase data
 */
export function setUserDataFirebase(user, authUser) {
	if (
		user &&
		user.data &&
		user.data.settings &&
		user.data.settings.theme &&
		user.data.settings.layout &&
		user.data.settings.layout.style
	) {
		// Set user data but do not update
		return setUserData(user);
	}

	// Create missing user settings
	return createUserSettingsFirebase(authUser);
}

/**
 * Create User Settings with Firebase data
 */
export function createUserSettingsFirebase(authUser) {
	return (dispatch, getState) => {
		const guestUser = getState().auth.user;
		const fuseDefaultSettings = getState().fuse.settings.defaults;
		const { currentUser } = firebase.auth();

		/**
		 * Merge with current Settings
		 */
		const user = _.merge({}, guestUser, {
			uid: authUser.uid,
			from: 'firebase',
			role: ['admin'],
			data: {
				displayName: authUser.displayName,
				email: authUser.email,
				settings: { ...fuseDefaultSettings }
			}
		});
		currentUser.updateProfile(user.data);

		updateUserData(user, dispatch);
		return dispatch(setUserData(user));
	};
}

/**
 * Set User Data
 */
export function setUserData(user) {
	//console.log('set user data')
	return dispatch => {
		/*
        You can redirect the logged-in user to a specific route depending on his role
         */

		// history.location.state = {
		//     redirectUrl: user.redirectUrl // for example 'apps/academy'
		// }

		/*
        Set User Settings
         */
		dispatch(FuseActions.setDefaultSettings(user));

		/*
        Set User Data
         */
		dispatch({
			type: SET_USER_DATA,
			payload: user
		});
	};
}

/**
 * Update User Settings
 */
export function updateUserSettings(settings) {
	return (dispatch, getState) => {
		const oldUser = getState().auth.user;
		const user = _.merge({}, oldUser, { data: { settings } });

		updateUserData(user, dispatch);

		return dispatch(setUserData(user));
	};
}

/**
 * Update User Shortcuts
 */
export function updateUserShortcuts(shortcuts) {
	return (dispatch, getState) => {
		const { user } = getState().auth;
		const newUser = {
			...user,
			data: {
				...user.data,
				shortcuts
			}
		};

		updateUserData(newUser, dispatch);

		return dispatch(setUserData(newUser));
	};
}

/**
 * Remove User Data
 */
export function removeUserData() {
	return {
		type: REMOVE_USER_DATA
	};
}

/**
 * Logout
 */
export function logoutUser(manual) {
	
	return (dispatch, getState) => {
		const { user } = getState().auth;
		console.log("logout user test 01/07, is logout manual ? ", manual)
		manual === true ? logout() : dispatch(UserActions.refreshToken())

		if (manual === true){
			console.log("logoutUser",user)
			if (!user.role || user.role.length === 0) {
				// is guest
				return null;
			}	

			//window.location.href = '/login';

			switch (user.from) {
				case 'firebase': {
					firebaseService.signOut();
					break;
				}
				case 'auth0': {
					auth0Service.logout();
					break;
				}
				default: {
					console.log(">>>>>>>>>>>>> logout 1")
					jwtService.logout();
				}
			}

			dispatch(FuseActions.setInitialSettings());

			localStorage.removeItem('current_user');
			localStorage.removeItem('access_token');
			localStorage.removeItem('id_token');
			localStorage.removeItem('expires_at');
			localStorage.removeItem('auth0.ssodata');
			localStorage.removeItem('jwt_access_token');
			localStorage.removeItem('ctm');
		
			return dispatch({
				type: USER_LOGGED_OUT
			});
		}
	};
}

function logout(){
	return (dispatch, getState) => {
		console.log("logout is called")
		let send_data = {
			
		}
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];
		const headersToken = {
			'Content-Type': 'application/json',
			headers: {"Authorization": `Token ${token}`}
		};
		return new Promise((resolve, reject) => {
			axios.post(process.env.REACT_APP_SERVER + '/api/auth/logout', send_data, headersToken).then(response => {
				console.log("logout is called well", response)
				if (response.data) {
					resolve(response.data);
					
						return dispatch({
							type: LOGOUT_SUCCESS
						});
					
					//window.location.href = '/login';
				} else {
					reject(response.data.error);
				}
			});
		});
	};
}

export function refreshToken(){
	return async (dispatch, getState) => {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];

		const config = {
			headers: { Authorization: `Token ${token}` }
		};
		const bodyParameters = {
			
		};
		
		const request = await axios.post(process.env.REACT_APP_SERVER + '/api/auth/token/refresh', 
									bodyParameters,
									config)                   
		
console.log("request ?? ", request)
		return request.then(response => {
				if (response.data) {
					this.setSession(response.data.authToken);
					localStorage.setItem('jwt_access_token', response.data.authToken);
				} else {
				}
			})
			.catch(error => {
				console.log('refreshAccessToken error', error);
			});


	}

}
	

/**
 * Update User Data
 */
function updateUserData(user, dispatch) {
	if (!user.role || user.role.length === 0) {
		// is guest
		return;
	}

	switch (user.from) {
		case 'firebase': {
			firebaseService
				.updateUserData(user)
				.then(() => {
					dispatch(MessageActions.showMessage({ message: 'User data saved to firebase' }));
				})
				.catch(error => {
					dispatch(MessageActions.showMessage({ message: error.message }));
				});
			break;
		}
		case 'auth0': {
			auth0Service
				.updateUserData({
					settings: user.data.settings,
					shortcuts: user.data.shortcuts
				})
				.then(() => {
					dispatch(MessageActions.showMessage({ message: 'User data saved to auth0' }));
				})
				.catch(error => {
					dispatch(MessageActions.showMessage({ message: error.message }));
				});
			break;
		}
		default: {
			jwtService
				.updateUserData(user)
				.then(() => {
					dispatch(MessageActions.showMessage({ message: 'User data saved with api' }));
				})
				.catch(error => {
					dispatch(MessageActions.showMessage({ message: error.message }));
				});
			break;
		}
	}
}
